import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import FocusTrap from "focus-trap-react";
import * as S from "./styles";

const ExternalLinkModal = ({ link, isOpen, onClose }) => {
  const [portalRoot, setPortalRoot] = useState(null);

  useEffect(() => {
    let el = document.getElementById("modal-root");

    if (!el) {
      el = document.createElement("div");
      el.setAttribute("id", "modal-root");
      document.body.appendChild(el);
    }

    setPortalRoot(el);
  }, []);

  useEffect(() => {
    const html = document.documentElement; // ✅ <html>
    const body = document.body; // ✅ <body>

    if (isOpen) {
      html.classList.add("no-scroll");
      body.classList.add("no-scroll");
    } else {
      html.classList.remove("no-scroll");
      body.classList.remove("no-scroll");
    }

    return () => {
      html.classList.remove("no-scroll");
      body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  if (!isOpen || !portalRoot) return null;

  const handleConfirm = () => {
    let finalLink = link;

    if (!finalLink.match(/^https?:\/\//i)) {
      finalLink = "http://" + finalLink;
    }

    window.open(finalLink, "_blank");
    onClose();
  };

  const modalUI = (
    <S.ModalPopUp>
      <FocusTrap>
        <S.ModalContent tabIndex="1">
          <S.ModalClose onClick={onClose}>CLOSE</S.ModalClose>

          <p>
            You will now be leaving this site and will be redirected to the
            Merck Medical Portal.
           </p>
            <p>
            The Merck Medical Portal is for health care professionals in the US
            and its territories only.
          </p>

          <S.LightBlueButton
            variant="primary"
            className="modal-button"
            onClick={handleConfirm}
          >
            Continue
            <S.ArrowWhiteBtn />
          </S.LightBlueButton>
        </S.ModalContent>
      </FocusTrap>
    </S.ModalPopUp>
  );

  //render outside DOM
  return ReactDOM.createPortal(modalUI, portalRoot);
};

export default ExternalLinkModal;
